export interface ValidationGroupModel {
    id: number;
    contact: string;
    email: string;
    clientAdminEmail: string ;
    addresses: string[];
    name: string;
    picture: string | null;
    disabled: boolean;
    licensesCount: number;
    restriction: any;
}

export default function validateGroup(model: ValidationGroupModel, isCreation: boolean, tabName: string, groups, currentGroup): string[] {
    const errors = {} as any;
    const nameAlreadyExists = groups.some(group => group.name.toLowerCase() === model.name.toLowerCase());
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    if (tabName === 'Main Info') {
        if (!model.name) {
            errors.name = "Client Name";
        }
        if ((nameAlreadyExists && isCreation) || (nameAlreadyExists && model.name !== currentGroup && !isCreation)) {
            errors.name = "Client Name: group with this name already exists";
        }
        if (!model.email) {
            errors.email = "Email";
        }
        if (model.email && !regex.test(model.email)) {
            errors.email = "Invalid email format";
        }
        if (!model.clientAdminEmail) {
            errors.clientAdminEmail = "Admin Email";
        }
        if (model.clientAdminEmail && !regex.test(model.clientAdminEmail)) {
            errors.clientAdminEmail = "Invalid admin email format";
        }
        if (model.addresses.length === 0) {
            errors.addresses = "Select at least one region";
        }
        if (model.licensesCount < 1) {
            errors.licensesCount = "Number of Licenses"
        }
        if (!model.picture) {
            //errors.picture = "Group must have picture logo";
            model.picture = 'data:image/png;base64,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';
        }
        if (!model.contact) {
            errors.contact = "Contact";
        }
        return errors;
    }
    if (tabName === 'Restrictions') {
        if (model.restriction.isDomainOnlyEnabled && model.restriction.domainsWithAccess === '') {
            errors.domainsWithAccess = "Domain name can't be empty";
        }
        if (model.restriction.devicesAllowedEnabled && model.restriction.devicesCount <= 0) {
            errors.domainsWithAccess = "Devices count must be more than 0";
        }
        return errors;
    }
    return errors;
};

